<template>
  <div class="fashion-ios-container">
    <h1>元邦時尚家 iOS</h1>
  </div>
</template>

<script>
export default {
  name: 'FashionIOS',
  mounted() {
    // 页面加载后直接跳转到App Store
    window.location.href = 'https://apps.apple.com/tw/app/%E5%85%83%E9%82%A6%E6%99%82%E5%B0%9A%E5%AE%B6/id6753136548'
  }
}
</script>

<style scoped>
.fashion-ios-container {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #007aff;
  margin-bottom: 20px;
}
</style>
